import { Dtos, type SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../utils/request";
import { financialStatementsListQueryKey } from "../account";
import { financialPeriodsQueryKey } from "./financials.keys";

export function useSubmitFinancialPeriodProfitability(accountId: SuretyAccountId) {
	const { post } = useRequest();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (body: Dtos.Agent.FinancialPeriod.Profitability.Upsert.Request) => {
			return await post<Dtos.Agent.FinancialPeriod.Profitability.UpsertOnPeriod.Response>(
				`/v2/surety/accounts/${accountId}/financial-periods/profitability`,
				body,
			);
		},
		onSuccess: async () => {
			await Promise.all([
				queryClient.invalidateQueries({
					queryKey: financialPeriodsQueryKey(accountId),
				}),
				queryClient.invalidateQueries({
					queryKey: financialStatementsListQueryKey(accountId),
				}),
			]);
		},
	});
}
